export type SettingsSection =
  | 'landing'
  | 'profile'
  | 'billing'
  | 'education-system'
  | 'external-resources'
  | 'users-hub'
  | 'users-account-details'
  | 'users-members'
  | 'users-invitations'
  | 'tutors';

export interface SettingsTile {
  id: Exclude<SettingsSection, 'landing'>;
  label: string;
  description: string;
  href: string;
  /** Shown only when user has sub-accounts (plan) */
  requiresSubAccounts?: boolean;
  /** Sub-accounts + org admin (same as former Users / Invitations tabs) */
  requiresOrgAdmin?: boolean;
}

const base = '#/app/settings';

export const settingsTiles: SettingsTile[] = [
  {
    id: 'profile',
    label: 'Your Profile',
    description: 'Your name, email, and account preferences.',
    href: `${base}/profile`
  },
  {
    id: 'billing',
    label: 'Billing',
    description: 'Subscription, payment method, and billing history.',
    href: `${base}/billing`
  },
  {
    id: 'users-hub',
    label: 'Users',
    description: 'Account details, organisation users, and invitations.',
    href: `${base}/users`,
    requiresSubAccounts: true
  },
  {
    id: 'education-system',
    label: 'Education System',
    description: 'Define custom education systems with key stages and years for your curriculum.',
    href: `${base}/education-system`
  },
  {
    id: 'external-resources',
    label: 'External Resources',
    description: 'Book publishers and online providers for units created from external materials.',
    href: `${base}/external-resources`
  }
];

export function parseSettingsPath(pathname: string): SettingsSection {
  const segments = pathname.split('/').filter(Boolean);
  const i = segments.indexOf('settings');
  const rest = i >= 0 ? segments.slice(i + 1) : [];

  if (rest.length === 0) return 'landing';

  if (rest[0] === 'profile') return 'profile';
  if (rest[0] === 'billing') return 'billing';
  if (rest[0] === 'education-system') return 'education-system';
  if (rest[0] === 'external-resources') return 'external-resources';
  if (rest[0] === 'tutors') return 'tutors';

  if (rest[0] === 'users') {
    if (rest[1] === 'account-details') return 'users-account-details';
    if (rest[1] === 'members') return 'users-members';
    if (rest[1] === 'invitations') return 'users-invitations';
    return 'users-hub';
  }

  return 'landing';
}
